import { useLocation } from "react-router-dom";
import seoData from "../seoData";

const SITE_URL = "https://mkaitechnology.com";

// Builds the canonical URL from the current path.
// Removes trailing slash (so /about/ and /about share one canonical)
// and ignores query strings / hashes.
const buildCanonical = (pathname) => {
  // Home stays "https://mkaitechnology.com/", other pages have no trailing slash
  if (pathname === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${pathname.replace(/\/+$/, "")}`;
};

const Seo = () => {
  const { pathname } = useLocation();
  const canonical = buildCanonical(pathname);

  // Same key rule as the canonical: no trailing slash, home stays "/"
  const key = pathname === "/" ? "/" : pathname.replace(/\/+$/, "") || "/";
  const data = seoData[key] || {};

  // React 19 automatically moves these tags into <head>.
  // title/description render only when a value is set in seoData.js.
  return (
    <>
      {data.title && <title>{data.title}</title>}
      {data.description && <meta name="description" content={data.description} />}
      <link rel="canonical" href={canonical} />
    </>
  );
};

export default Seo;